   
  var check;
    function scrollFunction(event) {

      if (!isScrolling) {
        var layer1 = document.querySelector('.about-hero-wrapper__desktop');
        var layer2 = document.querySelectorAll('.about-hero__image--main')[1];
        var layer3 = document.querySelector('.about-hero__image--mobile');
        var layer1Height = layer1.offsetHeight;
        var layer2Height = layer2.offsetHeight;
        var totalLayers = layer1Height + layer2Height;
        var isScrolling = false;
        requestAnimationFrame(function() {
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          var layer1Offset = scrollTop / 1;
          var window_height = Math.round(window.innerHeight);
          
          if (window_height > scrollTop ) {
            layer1.style.marginBottom =  - layer1Offset + 'px';
            layer2.style.marginBottom =  - layer1Offset + 'px';
    
            if (layer3.offsetWidth !== 0) {
              layer2.style.transform = 'translate3d(0px, 0px, 0px)';
            }
    
            if (scrollTop > totalLayers) {
              layer3.style.transform2 == 'translate3d(0px, ' + (scrollTop - totalLayers) + 'px, 0px)';
            } else {
              layer3.style.transform2 == 'translate3d(0px, 0px, 0px)';
            }
          }
          isScrolling = false;
        });
      }

    }


    window.addEventListener('scroll', scrollFunction); 
    window.addEventListener('resize', scrollFunction);
  
    scrollFunction();
